/**
 * Improved FAQ Accordion JavaScript
 * This script fixes responsiveness issues with the accordion
 */
document.addEventListener('DOMContentLoaded', function() {
  // Find all FAQ sections on the page
  const faqSections = document.querySelectorAll('.fatcat-faq-section');
  
  faqSections.forEach(function(section) {
    const accordionItems = section.querySelectorAll('.accordion-item');
    const accordionHeaders = section.querySelectorAll('.accordion-header');
    
    // Set up the initial state for all items
    accordionItems.forEach(function(item) {
      const header = item.querySelector('.accordion-header');
      const content = item.querySelector('.accordion-content');
      const contentInner = content.querySelector('.accordion-content-inner');
      
      // Set initial state based on active class
      if (item.classList.contains('active')) {
        header.setAttribute('aria-expanded', 'true');
        // Set content height to match inner content
        content.style.maxHeight = contentInner.offsetHeight + 'px';
      } else {
        header.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '0px';
      }
    });
    
    // Add click event listeners
    accordionHeaders.forEach(function(header) {
      header.addEventListener('click', function() {
        const item = this.parentNode;
        const content = item.querySelector('.accordion-content');
        const contentInner = content.querySelector('.accordion-content-inner');
        const isActive = item.classList.contains('active');
        
        // Close all accordion items
        accordionItems.forEach(function(accItem) {
          accItem.classList.remove('active');
          accItem.querySelector('.accordion-header').setAttribute('aria-expanded', 'false');
          accItem.querySelector('.accordion-content').style.maxHeight = '0px';
        });
        
        // If the clicked item wasn't active, open it
        if (!isActive) {
          item.classList.add('active');
          this.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = contentInner.offsetHeight + 'px';
        }
      });
    });
    
    // Recalculate heights on window resize to maintain responsiveness
    window.addEventListener('resize', function() {
      accordionItems.forEach(function(item) {
        if (item.classList.contains('active')) {
          const content = item.querySelector('.accordion-content');
          const contentInner = content.querySelector('.accordion-content-inner');
          content.style.maxHeight = contentInner.offsetHeight + 'px';
        }
      });
    });
  });
});